import { Experience } from './experience/Experience';
import { StoryOverlay } from './components/StoryOverlay';
import { useStoryProgress } from './experience/useStoryProgress';

export function App() {
  const progress = useStoryProgress();
  return (
    <main>
      <div className="experience" aria-hidden="true">
        <Experience progress={progress} />
      </div>
      <header className="brand-mark">ANNV</header>
      <div className="progress"><span style={{ transform: `scaleX(${progress})` }} /></div>
      <StoryOverlay progress={progress} />
      <div className="scroll-space" />
    </main>
  );
}
